module.exports = __webpack_public_path__ + "static/media/sandwich.94739f2a.jpg";